import React, {useEffect} from "react";
import "../CSS/styles.css";
import about from "../../assets/about.png";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Slider2 = () => {
  document.addEventListener('DOMContentLoaded', function () {
    window.scrollTo(0, 0);
  });
        useEffect(() => {
          AOS.init({
            duration: 1000,
            once: false,
          });
        }, []);

  return (
    <div className="container-fluid mt-lg-5 mt-4 px-0" data-aos="fade-down">
      <div className="row pt-4 justify-content-center">
        <div className="col-12">
          <div className="image-gradient-wrap3">
            <img src={about} alt="2" className="img-fluid" />
            <div className="gradient-over3"></div>
            <div className="over-cont3 d-flex flex-column align-items-center justify-content-center">
              <h1 className="fw-bolder inter h0 mb-0">About TAMBRO</h1>
              <p className="wrc text-center mb-0 mt-lg-3 mt-0">Your trusted partner for global risk management and security solutions.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Slider2;
